export default __webpack_public_path__ + "static/GRID22-how-to-read-data-conflict-fr-2846e0214661de85e01b1662eae6440e.png";